import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEChemicalCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Chemical Engineering",
    shortName: "B.E. Chemical",
    duration: "4 years",
    description: "Engineering program focused on chemical processes, manufacturing, and industrial production systems",
    overview: "Bachelor of Engineering in Chemical Engineering (B.E. Chemical) is a 4-year undergraduate program that applies principles of chemistry, physics, mathematics, and engineering to transform raw materials into useful products. This course covers process design, plant operations, safety systems, and environmental protection, preparing students for careers in chemical, pharmaceutical, petroleum, and process industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Strong foundation in chemistry and mathematics"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Chemical Engineering",
          "Material and Energy Balances"
        ]
      },
      {
        year: 2,
        subjects: [
          "Fluid Mechanics",
          "Heat Transfer",
          "Mass Transfer",
          "Chemical Engineering Thermodynamics",
          "Chemical Reaction Engineering",
          "Process Calculations"
        ]
      },
      {
        year: 3,
        subjects: [
          "Unit Operations",
          "Process Control and Instrumentation",
          "Chemical Plant Design",
          "Environmental Engineering",
          "Biochemical Engineering",
          "Industrial Chemistry"
        ]
      },
      {
        year: 4,
        subjects: [
          "Petroleum Refining",
          "Polymer Engineering",
          "Process Safety and Hazard Analysis",
          "Project Management",
          "Major Project",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Chemical Engineer",
        "Process Engineer",
        "Production Engineer",
        "Safety Engineer",
        "Environmental Engineer",
        "Quality Control Engineer",
        "Plant Manager",
        "Research and Development Engineer",
        "Technical Consultant",
        "Project Engineer"
      ],
      industries: [
        "Petroleum and Petrochemicals",
        "Pharmaceutical Industry",
        "Fertilizer Manufacturing",
        "Chemical Manufacturing",
        "Food and Beverage Processing",
        "Pulp and Paper Industry",
        "Environmental Consulting",
        "Oil and Gas Industry",
        "Paint and Polymer Industry",
        "Research and Development"
      ],
      averageSalary: "₹6-12 LPA (Fresher), ₹20-50 LPA (Experienced)",
      topRecruiters: [
        "ONGC, IOCL, BPCL, HPCL",
        "Reliance Industries, TATA Chemicals",
        "Dr. Reddy's, Cipla, Sun Pharma",
        "UPL, Coromandel International",
        "L&T, Technip",
        "Honeywell, ABB"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "A.C. College of Technology, Anna University",
        location: "Chennai",
        fees: "₹2,20,000",
        ranking: "NIRF Ranking: 48"
      },
      {
        name: "Coimbatore Institute of Technology",
        location: "Coimbatore",
        fees: "₹3,80,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      }
    ],

    skills: [
      "Process Design and Simulation",
      "ASPEN Plus/HYSYS",
      "MATLAB/Simulink",
      "AutoCAD Plant 3D",
      "Process Safety Analysis",
      "Heat and Mass Transfer",
      "Chemical Reaction Engineering",
      "Process Control",
      "Environmental Impact Assessment",
      "Project Management"
    ],

    futureScope: "Excellent growth prospects with expanding chemical industry, green chemistry initiatives, sustainable processes, and India's focus on chemical manufacturing and petrochemicals.",

    faqs: [
      {
        question: "What industries can Chemical Engineers work in?",
        answer: "Chemical Engineers can work in diverse industries including petroleum, pharmaceuticals, chemicals, food processing, environmental consulting, and many manufacturing sectors."
      },
      {
        question: "Is Chemical Engineering only about chemicals?",
        answer: "No, Chemical Engineering principles apply to any process involving transformation of materials - from food processing to semiconductor manufacturing and environmental cleanup."
      },
      {
        question: "What are the safety concerns in Chemical Engineering?",
        answer: "Safety is paramount in Chemical Engineering. The curriculum includes extensive training in process safety, hazard analysis, and risk management to ensure safe plant operations."
      },
      {
        question: "Can I work in the pharmaceutical industry?",
        answer: "Yes, pharmaceutical companies actively recruit Chemical Engineers for drug manufacturing, process development, quality control, and regulatory compliance roles."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEChemicalCoursePage;
